<template>
    <div>
        <card-header title="Trip Documents" icon="fa-file-alt"/>
        <card-toolbar>
            <button @click="$openCard('new-trip-document', {tripId: props.tripId}, card)"><i class="fas fa-plus mr-2"/>New Document</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <document-list-item
                    :card="card"
                    :doc="doc"
                    v-for="doc in documents"
                    :key="doc.id"
                    :active="(child && child.definition.component === 'edit-trip-document') && child.props.docId === doc.id.toString()"
                    @click="$openCard('edit-trip-document', {tripId: props.tripId, docId: doc.id}, card)"
                />
                <container-list-item padded v-if="!documents.length">
                    <p class="has-text-grey is-italic">No documents have been attached to this trip yet.</p>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardToolbar from "../../TIER/components/CardToolbar";
    import CardBody from "../../TIER/components/CardBody";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    import {client as http} from '../../http_client';
    import DocumentListItem from "@/components/DocumentListItem";

    export default {
        name: "TripDocuments",
        props: ['card', 'child', 'props'],
        components: {ContainerListItem, DocumentListItem, CardBody, CardToolbar, CardList, CardHeader},
        data: function() {
            return {
                documents: []
            };
        },
        methods: {
            load: function(force) {
                this.$emit('loading', true);
                http.get('/api/trips/' + this.props.tripId + '/documents', {force}).then(response => {
                    this.documents = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.load(true);
            }
        },
        mounted() {
            this.load(true);
        }
    };
</script>

<style lang="scss" scoped>

</style>
